import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import store from '../redux/store';
import MainLayout from '../components/layouts/MainLayout';
import PropTypes from 'prop-types';
import ErrorBoundary from '../components/features/errorBoundary/ErrorBoundary';
import { gtmId } from '../constants/analytics/GTM';
import { apmInit } from '../utils/analytics/apm';
import GTMProvider from '../utils/GTMProvider';
import ApplicationCallbacksProvider from '../providers/application-callbacks';
import { debounce } from 'lodash';
import '../styles/main.scss';

apmInit();

const MyApp = ({ Component, pageProps }) => {
  useEffect(() => {
    const htmlPoint = document.getElementById('html-point');
    const classListBody = document.body?.classList;

    if (!htmlPoint || !classListBody) return;

    const appHeight = () => {
      const h = window.innerHeight;
      const w = window.innerWidth;
      const rulesDesk = w / h > 1280 / 640;
      const rulesMob = w / h > 360 / 640;
      const rulesTab = w / h > 768 / 860;

      htmlPoint.style.setProperty('--app-height', `${h}px`);
      htmlPoint.style.setProperty('--app-width', `${w}px`);

      classListBody.toggle('landscape', rulesDesk && w >= 1024);
      classListBody.toggle('landscape-mob', rulesMob && w < 768);
      classListBody.toggle('landscape-tab', rulesTab && w < 1024 && w >= 768);
      classListBody.toggle('portrait', !rulesDesk && w >= 1024);
      classListBody.toggle('portrait-mob', !rulesMob && w < 768);
      classListBody.toggle('portrait-tab', !rulesTab && w < 1024 && w >= 768);
    };

    const debouncedHeight = debounce(appHeight, 100);
    window.addEventListener('resize', debouncedHeight);
    debouncedHeight();

    return () => {
      window.removeEventListener('resize', debouncedHeight);
      debouncedHeight.cancel();
    };
  }, []);

  return (
    <ErrorBoundary>
      <GTMProvider gtmId={gtmId}>
        <Provider store={store}>
          <ApplicationCallbacksProvider>
            <MainLayout>
              <Component {...pageProps} />
            </MainLayout>
          </ApplicationCallbacksProvider>
        </Provider>
      </GTMProvider>
    </ErrorBoundary>
  );
};

MyApp.propTypes = {
  Component: PropTypes.elementType,
  pageProps: PropTypes.object,
};

export default MyApp;
